import { useNavigate } from "react-router-dom"
import { useAppDispatch, useAppSelector } from "../../app/hooks"
import { ReloadIcon } from "../../images/Icons"
import { loadPartyEventsAsync } from "../partyEvents/partyEventsSlice"
import { sanitizeEmail } from "../../utils/emailUtils"
import { useAuth0 } from "@auth0/auth0-react"
import { loadNotificationAsync, markAsViewedNotificationAsync, selectNotifications, setNewNotificationReceived } from "../notifications/notificationsSlice"

export function ReloadNotificationButton() {
    const dispatch = useAppDispatch()
    const notifications = useAppSelector(selectNotifications)
    
    const { user, isAuthenticated, getAccessTokenSilently } = useAuth0()  
      return (
        <div className='iconButtons' onClick={async (e) => {
            e.stopPropagation()
            if (isAuthenticated){
                           try {
                               const accessToken = await getAccessTokenSilently({ authorizationParams : {
                               }})
                               if (user?.email){
                                   dispatch(loadNotificationAsync({
                                       email:sanitizeEmail(user?.email),
                                       token: accessToken
                                   }))
                                   dispatch(setNewNotificationReceived(false))
                                   notifications.map((notification ) =>
                                   {
                                       if (!notification.viewed && user?.email != null) {
                                           dispatch(markAsViewedNotificationAsync({
                                               email: sanitizeEmail(user.email),
                                               token: accessToken,
                                               notificationId: notification.id
                                           }))
                                       }
                                   })
                               }
                           }
                           catch (error) {}
                       }}}><ReloadIcon/></div>
    )
}